// import React from 'react';
// import { Link } from 'react-router-dom';
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
// import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/table";
// import Footer from '../../../components/Footer';
// import MtechImg from "../../../assets/images/engineering.jpeg";

// const programDetails = {
//     name: "M.Tech in Digital Communication Engineering",
//     about: "M.Tech. (Master of Technology) in Digital Communication Engineering is a postgraduate degree program that focuses on various machine learning algorithms and techniques for building predictive models from data. Topics include supervised learning, unsupervised learning, reinforcement learning, neural networks, and deep learning. Students also explore technologies and platforms for processing, analyzing, and deriving insights from large-scale datasets.",
//     eligibility: "Bachelor's degree in Engineering/Technology or equivalent, or a Master's degree in Science/MDU Entrance Examination",
// };

// const programFees = {
//     program: "Master of Technology (M.Tech)",
//     branch: "Digital Communication Engineering",
//     duration: "2",
//     seats: "20",
//     registrationFee: "16000",
//     allIndiaFee: "100000",
//     ukDomicileFee: "75000",
// };

// const scholarships = [
//     { id: 1, particulars: "Single Girl Child", category: "", percentage: "10%", applicable: "All Years" },
//     { id: 2, particulars: "Merit Based", category: "75%-80%", percentage: "20%", applicable: "*" },
//     { id: 3, particulars: "Merit Based", category: "80%-90%", percentage: "30%", applicable: "*" },
//     { id: 4, particulars: "Merit Based", category: "90%-95%", percentage: "40%", applicable: "*" },
// ];

// const MtechDigitalCommunication = () => {
//     return (
//         <div className="w-full relative font-poppins bg-gray-50">
//             <div className="w-11/12 lg:w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 pb-16">
//                 <Card className="border-none shadow-lg">
//                     <CardHeader className="space-y-4 text-center">
//                         <CardTitle className="text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38]">
//                             {programDetails.name}
//                         </CardTitle>
//                         <div className="w-20 h-1 bg-[#23376c] mx-auto"></div>
//                     </CardHeader>
//                     <CardContent>
//                         <div className="flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between">
//                             <div className="md:w-[30%] relative group">
//                                 <img
//                                     src={MtechImg}
//                                     className="rounded-lg w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//                                     alt="M.Tech Digital Communication"
//                                 />
//                                 <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg"></div>
//                             </div>
//                             <div className="flex flex-col gap-4 md:w-[65%]">
//                                 <h4 className="font-bold text-xl md:text-3xl text-[#23376c]">About the Department</h4>
//                                 <p className="text-justify md:text-lg text-gray-700 leading-relaxed">{programDetails.about}</p>
//                                 <Link to="https://admission.maya.edu.in/">
//                                     <button className="mt-5 md:mt-0 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] hover:shadow-lg transform hover:-translate-y-1">
//                                         Register Now
//                                     </button>
//                                 </Link>
//                             </div>
//                         </div>
//                     </CardContent>
//                 </Card>

//                 <Card className="border-none shadow-lg">
//                     <CardContent className="mt-5 p-6">
//                         <h4 className="text-2xl font-semibold text-[#0e4d38] mb-4">Eligibility Criteria</h4>
//                         <p className="text-gray-700 leading-relaxed">{programDetails.eligibility}</p>
//                     </CardContent>
//                 </Card>

//                 {/* Program Fee Table */}
//                 <Card className="border-none shadow-lg">
//                     <CardContent className="p-0">
//                         <div className="overflow-x-auto">
//                             <Table className="min-w-full">
//                                 <TableHeader>
//                                     <TableRow className="bg-[#23376c]">
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Programme</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Branch</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Duration</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Seats</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Registration Fee</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Yearly Fee (All India)</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Yearly Fee (UK Domicile)</TableHead>
//                                     </TableRow>
//                                 </TableHeader>
//                                 <TableBody>
//                                     <TableRow className="hover:bg-gray-50">
//                                         <TableCell className="font-medium px-2 py-1 text-xs md:text-sm whitespace-nowrap">{programFees.program}</TableCell>
//                                         <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">{programFees.branch}</TableCell>
//                                         <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">{programFees.duration}</TableCell>
//                                         <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">{programFees.seats}</TableCell>
//                                         <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">{`₹${programFees.registrationFee}/-`}</TableCell>
//                                         <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">{`₹${programFees.allIndiaFee}/-`}</TableCell>
//                                         <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">{`₹${programFees.ukDomicileFee}/-`}</TableCell>
//                                     </TableRow>
//                                 </TableBody>
//                             </Table>
//                         </div>
//                     </CardContent>
//                 </Card>

//                 {/* Scholarship Table */}
//                 <Card className="border-none shadow-lg mt-10">
//                     <CardContent className="p-0">
//                         <div className="overflow-x-auto">
//                             <Table className="min-w-full">
//                                 <TableHeader>
//                                     <TableRow className="bg-[#23376c]">
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Sr. No</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Particulars</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Category</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Percentage</TableHead>
//                                         <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Applicable</TableHead>
//                                     </TableRow>
//                                 </TableHeader>
//                                 <TableBody>
//                                     {scholarships.map((scholarship) => (
//                                         <TableRow key={scholarship.id} className="hover:bg-gray-50">
//                                             <TableCell className="px-2 py-1 text-xs md:text-sm">{scholarship.id}</TableCell>
//                                             <TableCell className="px-2 py-1 text-xs md:text-sm">{scholarship.particulars}</TableCell>
//                                             <TableCell className="px-2 py-1 text-xs md:text-sm">{scholarship.category}</TableCell>
//                                             <TableCell className="px-2 py-1 text-xs md:text-sm">{scholarship.percentage}</TableCell>
//                                             <TableCell className="px-2 py-1 text-xs md:text-sm">{scholarship.applicable}</TableCell>
//                                         </TableRow>
//                                     ))}
//                                 </TableBody>
//                             </Table>
//                         </div>
//                     </CardContent>
//                 </Card>
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default MtechDigitalCommunication;







import React from 'react';
import Footer from '../../../components/Footer';
import BtechImg from "../../../assets/images/engineering.jpeg"; // Update with a relevant cyber security image
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
    Shield,
    GraduationCap,
    Lock,
    Target,
    BookOpen,
    FlaskConical,
    MapPin,
    Users,
    Code,
} from 'lucide-react';
import Title from '../../../components/TitleComponent';

const MtechDigitalCommunication = () => {
    const fadeIn = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 }
    };

    return (
        <div className='w-full relative font-poppins'>
            <Title canonicalPath="/programmes/pg-courses/engineering/mtech/digital-communication
" />
            <Title title="M.Tech in Digital Communication at Top Colleges in India
" description="Pursue M.Tech in Digital Communication from leading Indian institutes. Enhance your expertise in communication systems, signal processing, and network technologies.
" />
            {/* Hero Section */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className='relative h-[300px] md:h-[400px] bg-[#0e4d38] mt-[60px] md:mt-[80px] overflow-hidden'
            >
                <div className='absolute inset-0 bg-black/50'></div>
                <div className='relative z-10 h-full flex flex-col justify-center items-center text-white px-4'>
                    <h1 className='text-3xl md:text-6xl font-bold text-center mb-4'>
                        M.Tech in Digital Communication
                    </h1>
                </div>
            </motion.div>

            <div className='w-11/12 md:w-10/12 mx-auto mt-8 md:mt-16'>
                {/* About Section */}
                <motion.div
                    {...fadeIn}
                    className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px]'
                >
                    <img src={BtechImg} className='md:w-[40%] rounded-xl shadow-lg' alt="Cyber Security" />
                    <div className='flex flex-col gap-4'>
                        <div className='flex items-center gap-3'>
                            <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                                <Shield size={24} />
                            </div>
                            <h4 className='font-bold text-2xl md:text-3xl text-[#0e4d38]'>Program Overview</h4>
                        </div>
                        <div className='text-justify md:text-lg space-y-4 text-gray-700'>
                            Digital Communication is an essential field in Electrical Engineering that focuses on the transmission, processing, and reception of digital signals for efficient communication systems. MDU offers a comprehensive two-year Master's program in Digital Communication, where students delve into advanced concepts of communication theory, digital modulation techniques, coding, signal processing, and network protocols. The curriculum is designed to provide a deep understanding of modern communication systems, including wireless communications, satellite systems, optical communication, and broadband technologies. Students also explore cutting-edge topics like MIMO (Multiple Input Multiple Output) systems, 5G/6G networks, and Internet of Things (IoT) communication, preparing them for the rapidly evolving telecommunications industry. <br />
                            This program equips students with practical knowledge through both theoretical coursework and handson experience with communication system design, signal analysis, and optimization. Students will learn to work with state-of-the-art tools and software, such as MATLAB, LabVIEW, and simulation platforms, enhancing their ability to design and test real-world communication systems. Upon completion of the program, graduates will be well-prepared for leadership roles in industries like telecommunications, networking, broadcasting, and wireless communication.

                        </div>
                        <Link to="https://admission.maya.edu.in/">
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className='mt-5 md:mt-4 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2'
                            >
                                <GraduationCap size={20} />
                                Apply Now
                            </motion.button>
                        </Link>
                    </div>
                </motion.div>

                {/* Learning Outcomes */}
                <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
                    <div className='flex items-center gap-3 mb-6'>
                        <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                            <Target size={24} />
                        </div>
                        <h4 className='font-bold text-2xl text-[#0e4d38]'>Learning Outcomes</h4>
                    </div>
                    <p className='text-gray-700 leading-relaxed mb-4'>
                        As digital communication continues to evolve, advancements in wireless technologies, optical networks, and the growing demand for high-speed internet will drive the development of next-generation systems. The emergence of 5G/6G networks, the expansion of the Internet of Things (IoT), and the increasing use of satellite communication for global connectivity all present exciting opportunities for professionals in this field. The M.Tech in Digital Communication from MDU prepares students to lead and innovate in these areas, offering them a strong foundation to contribute to the future of global communication systems. Upon completing this program, students can take up careers in various fields such as:
                    </p>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        {[
                            "•	Signal Processing Engineer ",
                            "•	IoT Engineer ",
                            "•	Network Architect ",
                            "•	Telecommunication Systems Engineer ",
                            "•	Network Security Engineer ",
                        ].map((role, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.02 }}
                                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
                            >
                                <p className='text-gray-700 font-medium'>{role}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Laboratories and Facilities */}
                <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
                    <div className='flex items-center gap-3 mb-6'>
                        <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                            <Code size={24} />
                        </div>
                        <h4 className='font-bold text-2xl text-[#0e4d38]'>Laboratories and Facilities</h4>
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        {[
                            "•	Signal Processing Laboratory ",
                            "•	Wireless Communication Laboratory ",
                            "•	Digital Communication Laboratory ",
                            "•	Optical Communication Laboratory ",
                        ].map((lab, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.02 }}
                                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
                            >
                                <p className='text-gray-700 font-medium'>{lab}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Admission Requirements */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-white p-6 rounded-xl shadow-lg mb-12"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <div className="p-2 rounded-lg bg-[#0e4d38] text-white">
                            <GraduationCap size={24} />
                        </div>
                        <h4 className="font-bold text-2xl text-[#0e4d38]">Admission Requirements</h4>
                    </div>

                    <div className="space-y-4">
                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Duration of the Program:</span> 2 Years (Semester System)
                            </p>
                        </div>

                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Affiliation:</span> Constituent College of Maya Devi University
                            </p>
                        </div>

                        <div className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full mt-2"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Eligibility Criteria:</span> Candidate shall have passed BE/B.Tech or equivalent examination in relevant discipline with minimum 55% for Open Category (45% for SC/ST/OBC Candidates), and have qualified GATE or MDU entrance examination, followed by an interview.
                            </p>
                        </div>

                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Mode of Admission:</span> As per university procedure
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default MtechDigitalCommunication;

